<template>
    <div class="saturnalia-map-wrapper">
        <iframe frameBorder="0" class="sat-iframe" :src="iframeUrl"></iframe>
    </div>
</template>

<script>
export default {
    name: "SaturnaliInfo",
    head() {
        return {
            title: 'Saturnalia information | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                },
                {
                    hid: 'robots',
                    name: 'robots',
                    content: 'noindex'
                }
            ],
            bodyAttrs: {
                class: 'barcode-page'
            }
        }
    },
    data() {
        return {
            iframeUrl: ''
        }
    },
    mounted() {
        let _lwin = this.$route.query.lwin;
        let _vintage = this.$route.query.vintage;
        this.iframeUrl = 'https://vindome.net/saturnalia-info-iframe/?lwin=' + _lwin + '&vintage=' + _vintage
    }
}
</script>

<style scoped>
.sat-iframe {
    width: 100%;
    height: 100%;
    min-height: 300px;
    padding: 0;
    margin: 0;
}
</style>
<style>
.barcode-page .theme--dark.v-sheet.header-toolbar,
.barcode-page .main-footer,
.barcode-page .header-toolbar-not-logged,
.cc_dialog.headline,
.barcode-page .smartbanner,
.barcode-page #iubenda-cs-banner  {
    display: none !important;
}

.barcode-page .v-main {
    padding-top: 0 !important;
}

.smartbanner-show {
    margin-top: 0 !important;
}
</style>
